import { CachedCRUDService } from '../../../types/cached-c-r-u-d.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ServerResponse } from '../../../types/http.interfaces';
import { environment } from '../../../../../environments/environment';
import { ParametricsInterface } from '../../../types/parametrics.interface';
import { EthnicityChangeStatusInput, EthnicityCreateInput } from '@sisem/sisem-incidents-types';

@Injectable({
  providedIn: 'root',
})
export class IncidentsEthnicitiesService extends CachedCRUDService<
  ParametricsInterface,
  EthnicityCreateInput['data'],
  never
> {
  constructor(private http: HttpClient) {
    super();
    this.options.cacheExpiration = -1; // should almost never change, set don't expire
  }

  protected override async _fetchNewData(): Promise<ParametricsInterface[]> {
    const response = await lastValueFrom(
      this.http.get<ServerResponse<ParametricsInterface[]>>(
        `${environment.api}/incidents-ms/api/v1/ethnicities`
      )
    );
    return response.data;
  }

  protected override async _getByIdData(id: number): Promise<ParametricsInterface | undefined> {
    const res = await lastValueFrom(
      this.http.get<ServerResponse<ParametricsInterface>>(
        `${environment.api}/incidents-ms/api/v1/ethnicities/${id}`
      )
    );
    return res.data;
  }

  protected override async _postData(input: EthnicityCreateInput['data']) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    const res = await lastValueFrom(
      this.http.post<ServerResponse<ParametricsInterface>>(
        `${environment.api}/incidents-ms/api/v1/ethnicities`,
        input,
        { headers }
      )
    );
    const fixedRes = await this.getById(res.data.id, true);
    if (!fixedRes) {
      throw new Error('Could not fetch updated data');
    }
    this.removeId(res.data.id);
    return fixedRes;
  }

  protected override async _deleteData(_id: number): Promise<void> {
    await lastValueFrom(
      this.http.delete(`${environment.api}/incidents-ms/api/v1/ethnicities/${_id}`)
    );
  }

  async changeEthnicityStatus(id: number, data: EthnicityChangeStatusInput['data']) {
    try {
      await lastValueFrom(
        this.http.post(`${environment.api}/incidents-ms/api/v1/ethnicities/${id}/status`, data)
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
